// extracted by css-extract-rspack-plugin
export default {"regexInputContainer":"DefinitionRegexEditor-module__regexInputContainer__YQ09q","testRegexButton":"DefinitionRegexEditor-module__testRegexButton__iw8kE"};